import { useEffect, useState } from 'react';
import { fetchAreas } from 'Api/developmentPlanMainPage';

const useFetchAreas = () => {
  const [allTerminals, setAllTerminals] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const [allJobTitles, setAllJobTitles] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchAreas().then(data => {
      setAllTerminals(data.terminal);
      setAllDepartments(data.department);
      setAllJobTitles(data.jobTitle);
      setCategories(data.categories);
    });
  }, []);

  return { allTerminals, allDepartments, allJobTitles, categories };
};

export default useFetchAreas;
